import React, { useEffect, useState } from "react";
import EngagementCard from "src/components/engagement-card";
import EngagementManagerHeader from "src/components/engagement-manager-header";
import store from "src/store";
import Progress from "src/components/progress";
import RefreshIcon from "@material-ui/icons/Refresh";
import useIsLoggedIn from "src/utils/use-is-logged-in";
import EngagementManagerFilters from "src/components/engagement-manager-filters";
import Disclaimer from "src/components/disclaimer";

export default function EngagementManager() {
    const { isLoggedIn, userInfo } = useIsLoggedIn();
    const [loading, setLoading] = useState(true);

    const getEngagementList = async () => {
        setLoading(true);
        await store.fetchEngagements();
        setLoading(false);
    };

    useEffect(() => { 
        if (store.hasEngagementManagerAccess) { 
            getEngagementList(); 
            store.fetchUserOrganizations(); 
        } 
    }, [store.hasEngagementManagerAccess]);

    const getEngagementError = () => {
        if (store.engagements === undefined || !Array.isArray(store.engagements)) {
            return 'Unable to fetch engagements';
        } else {
            return 'No engagement found';
        }
    }

    store.useRerenderIfChange(() => [store.engagements, store.hasEngagementManagerAccess]);

    return (
        <> {
            (isLoggedIn && store.hasEngagementManagerAccess) ?
                <div css={`
                    padding:35px;
                    background:#F6F6FA;
                    min-height:100vh;
                `}>
                    <div>
                        <EngagementManagerHeader engagements={store.engagements} />
                        <Disclaimer />
                    </div>
                    <hr css={`
                        margin-top:15px;
                        border: 1px solid #EAEAF2;
                        `}
                    />
                    <div css={`
                        margin-bottom:100px;
                        overflow: auto;
                    `}>
                        {
                            (!loading && store.allEngagements?.length && !userInfo?.auth0Subscripton) ?
                                <EngagementManagerFilters/> : null
                        }

                        {loading && <Progress />}

                        {!loading && <div css={`
                            display: grid;
                            grid-template-columns: repeat(2, 1fr);
                            gap: 20px;
                        `}>
                            {
                                store.engagements?.length ?
                                    store.engagements?.map((item, index) =>
                                        <EngagementCard key={index} engagement={item} />
                                    )
                                    : getEngagementError()
                            }
                        </div>}
                    </div >
                </div> :
                <div css={`
                    padding:35px;
                    background:#F6F6FA;
                    min-height:100vh;
                `}>
                    <h2 css="color: red;">Access denied!</h2>
                </div>
        }
        </>
    )
}
